import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import * as Sentry from '@sentry/react';
// Import por efecto secundario: registra los listeners de instalación antes de que
// React monte nada. Ver el encabezado de installPrompt.ts para el porqué del orden.
import './lib/installPrompt';

// Configuración de Sentry
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  environment: import.meta.env.PROD ? 'production' : 'development',
  // Ruido benigno de Sentry Replay (rrweb): al enviar un reporte, html2canvas
  // clona y desmonta nodos del DOM para la captura, y el grabador intenta
  // serializar un nodo ya desprendido. No es un defecto de la app y la captura
  // se genera bien; lo filtramos para que no genere issues automáticos.
  ignoreErrors: ["Failed to execute 'selectNode' on 'Range'"],
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
